(function ($) {
  "use strict";

  /**
   * MOBILE NAV
   */
  var $navbarStart = null;
  var $rootUl = null;
  var $activeSection = null; // the root-level li we drilled into

  var STAGGER_DELAY = 75; // ms between each li fading in
  var SECTION_STAGGER_DELAY = 100; // ms between each li fading in on mobile section drill
  var FADE_DURATION = 250; // ms for the fadeIn itself, used everywhere

  var mobileMenuHasOpened;

  $(document).on("click", ".navbar-brand .hamburger", function () {
    let allLinks = $(".navbar-end > ul > li");
    if (allLinks.length == 0 || mobileMenuHasOpened) return;

    allLinks.fadeOut(0);

    allLinks.each(function (index) {
      var $item = $(this);
      setTimeout(function () {
        $item.fadeIn(FADE_DURATION);
      }, index * STAGGER_DELAY);
    });

    mobileMenuHasOpened = true;
  });

  function isMobile() {
    return window.innerWidth < breakPoints.navBar;
  }

  function isRealLink(anchor) {
    var href = $(anchor).attr("href");
    if (!href || href.trim() === "" || href.trim() === "#") return false;
    return true;
  }

  function slugify(str) {
    return str
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  }

  function addAriaAttrs($root) {
    var counter = 0;
    $root.find(".expand-submenu").each(function () {
      var $btn = $(this);
      var $li = $btn.closest("li");
      var $child = $li.children("ul");
      if (!$child.length) return;
      if (!$child.attr("id")) {
        var label = $li.children("a").first().text().trim();
        label = label ? slugify(label) : "menu";
        $child.attr("id", "submenu-" + label + "-" + ++counter);
      }
      $btn.attr("aria-controls", $child.attr("id"));
      $btn.attr("aria-expanded", "false");
      if (!$btn.attr("aria-label") && !$btn.text().trim()) {
        var name = $li.children("a").first().text().trim() || "submenu";
        $btn.attr("aria-label", "Expand " + name + " submenu");
      }
    });
  }

  function backBtn() {
    return $(".endo-mobile-back");
  }

  // Does this link point at a fragment on the page we are already on?
  function samePageHash(anchor) {
    if (!anchor.hash || anchor.hash === "#") return null;
    if (anchor.host !== window.location.host) return null;
    if (anchor.search !== window.location.search) return null;
    var strip = function (path) {
      return path.replace(/\/+$/, "");
    };
    if (strip(anchor.pathname) !== strip(window.location.pathname)) return null;
    return anchor.hash;
  }

  function hashTarget(hash) {
    var id = decodeURIComponent(hash.slice(1));
    if (!id) return null;
    return (
      document.getElementById(id) || document.getElementsByName(id)[0] || null
    );
  }

  // Close the off-canvas menu via the hamburger so JellyfishUI keeps its own
  // state (body.has-active-nav, aria-expanded) in sync.
  function closeOffCanvas() {
    var $navMenu = $(".navbar-menu.is-off-canvas");
    if (!$navMenu.hasClass("is-active")) return;

    var $toggle = $navMenu.find(".hamburger").first();
    if (!$toggle.length) $toggle = $(".navbar .hamburger").first();
    if ($toggle.length) $toggle[0].click();

    // Drop back to the root level once the close animation has finished
    setTimeout(function () {
      if ($rootUl) showRoot();
    }, 600);
  }

  function scrollToHash(hash, target) {
    if (window.history && window.history.pushState) {
      window.history.pushState(null, "", hash);
    }
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
    target.focus({ preventScroll: true });
  }

  // Show the root level — all top-level lis, nothing inside child uls
  function showRoot() {
    // Clean up the previous active section
    if ($activeSection) {
      $activeSection.removeClass("drop-active");
      $activeSection.children(".expand-submenu").attr("aria-expanded", "false");
      // $activeSection.find("ul, li").hide();
    }
    $activeSection = null;
    $rootUl.children("li").show();
    backBtn().addClass("hide");
  }

  // Drill into a top-level li that has children
  function openSection($li) {
    $activeSection = $li;

    $rootUl.children("li").hide();

    $li.addClass("drop-active").show();
    // $li.find("> a").hide().fadeIn(FADE_DURATION);

    $li.find("ul").show();
    $li.children(".expand-submenu").attr("aria-expanded", "true");

    var $items = $li.children("ul").children("li").hide();

    $items.each(function (index) {
      var $item = $(this);
      setTimeout(function () {
        $item.fadeIn(FADE_DURATION);
      }, index * SECTION_STAGGER_DELAY);
    });

    backBtn().removeClass("hide");
  }

  function init() {
    var $navMenu = $(".navbar-menu.is-off-canvas");
    if (!$navMenu.length) return;

    $navbarStart = $navMenu.find(".navbar-end");
    if (!$navbarStart.length) return;

    $rootUl = $navbarStart.children("ul").first();
    if (!$rootUl.length) return;

    addAriaAttrs($navbarStart);

    var $navbar = $navMenu.closest(".navbar");

    // Anchor links pointing at the current page never scroll while the menu is
    // open — the off-canvas menu locks scrolling (body.has-active-nav) and the
    // mega menu sits over the target. Close the menu first, then scroll.
    // Registered before the handlers below so it wins the capture phase.
    document.addEventListener(
      "click",
      function (e) {
        if (!e.target.closest) return;
        var anchor = e.target.closest("a[href]");
        if (!anchor || !$navbar.length || !$navbar[0].contains(anchor)) return;

        var hash = samePageHash(anchor);
        if (!hash) return;

        var target = hashTarget(hash);
        if (!target) return; // nothing to scroll to — leave it to the browser

        e.preventDefault();
        e.stopImmediatePropagation();

        if (isMobile()) {
          closeOffCanvas();
        } else {
          clearMegaMenu();
        }

        scrollToHash(hash, target);
      },
      true,
    );

    // Back button — looked up at call time in case framework moves it in the DOM
    $(document).on("click", ".endo-mobile-back", function (e) {
      e.preventDefault();
      e.stopPropagation();
      showRoot();
    });

    // Intercept li.has-children > a (capture phase to beat JellyfishUI)
    document.addEventListener(
      "click",
      function (e) {
        if (!isMobile()) return;
        if (!$navbarStart[0].contains(e.target)) return;
        var anchor = e.target.closest(
          "li.has-children > a, li.menu-item-has-children > a",
        );
        if (!anchor) return;
        if (isRealLink(anchor)) {
          e.stopImmediatePropagation();
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        var $btn = $(anchor).closest("li").children(".expand-submenu");
        if ($btn.length) $btn[0].click();
      },
      true,
    );

    // Only top-level expand buttons open a section
    $navbarStart.on("click", ".expand-submenu", function (e) {
      if (!isMobile()) return;
      e.preventDefault();
      e.stopPropagation();

      var $btn = $(this);
      var $li = $btn.closest("li");

      // Only act on root-level lis
      if (!$rootUl.children("li").is($li)) return;

      openSection($li);
    });

    // Reset when off-canvas closes
    // if ("MutationObserver" in window) {
    //   var observer = new MutationObserver(function (mutations) {
    //     $.each(mutations, function (i, mutation) {
    //       if (mutation.attributeName === "class") {
    //         if (!$navMenu.hasClass("is-active")) {
    //           setTimeout(showRoot, 600);
    //         }
    //       }
    //     });
    //   });
    //   observer.observe($navMenu[0], { attributes: true });
    // }
  }

  $(document).ready(init);

  /**
   * DESKTOP NAV
   */
  var $activeLi = null;

  function clearMegaMenu(keepHeight) {
    if ($activeLi) {
      var $subMenu = $("#mega-menu").children("ul").detach();
      if ($subMenu.length) $activeLi.append($subMenu);
      $activeLi.removeClass("drop-active").attr("aria-expanded", "false");
      $activeLi.children("a").removeClass("clicked");
      $activeLi = null;
    }
    if (!keepHeight) {
      $("#mega-menu").removeClass("is-active").css("height", 0);
    }
  }

  function openMegaMenu($li) {
    var $subMenu = $li.children("ul").detach();
    $("#mega-menu").html("").append($subMenu);

    $li.addClass("drop-active").attr("aria-expanded", "true");
    $li.children("a").addClass("clicked");
    $activeLi = $li;

    var $container = $li.closest(".container");
    var liOffset = $li.offset().left;
    var containerOffset = $container.offset().left;
    var liLeft = liOffset - containerOffset;
    var liCenter = liLeft + $li[0].clientWidth / 2;

    $("#mega-menu").css("--marker-position", liCenter + "px");

    $("#mega-menu").addClass("is-active").css("height", "auto");

    // Stagger immediate child lis
    var $items = $("#mega-menu").children("ul").children("li").hide();
    $items.each(function (index) {
      var $item = $(this);
      $item.fadeIn(FADE_DURATION * 1.5);

      // setTimeout(
      //   function () {
      //     $item.fadeIn(FADE_DURATION);
      //   },
      //   index * STAGGER_DELAY * 0.5,
      // );
    });

    $("#mega-menu")[0].focus();
  }

  function initDesktop() {
    document.addEventListener(
      "click",
      function (e) {
        if (isMobile()) return;

        // Click outside — clear everything
        if (
          !document.querySelector(".navbar").contains(e.target) &&
          !document.querySelector("#mega-menu").contains(e.target)
        ) {
          clearMegaMenu();
          return;
        }

        var anchor = e.target.closest(
          "li.has-children > a, li.menu-item-has-children > a",
        );

        if (!anchor) return;

        // Only act on links inside the navbar, not inside the mega menu
        if (document.querySelector("#mega-menu").contains(anchor)) return;

        var $li = $(anchor).closest("li");

        // Second click on same item
        if ($activeLi && $activeLi.is($li)) {
          if (isRealLink(anchor)) {
            clearMegaMenu();
            return; // allow default navigation
          }
          clearMegaMenu();
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        // Clicking a different item — clear but keep height, then open
        clearMegaMenu(true);
        openMegaMenu($li);
      },
      true,
    );

    // Escape key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") clearMegaMenu();
    });
  }

  var wasMobile = isMobile();

  jfDebounce(
    "resize",
    function () {
      var nowMobile = isMobile();
      if (wasMobile === nowMobile) return; // no breakpoint crossed, do nothing

      if (nowMobile) {
        // crossed to mobile
        clearMegaMenu();
      } else {
        // crossed to desktop
        showRoot();
        $activeSection = null;
      }

      wasMobile = nowMobile;
    },
    0,
  );

  $(document).ready(initDesktop);
})(jQuery);
